
import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'
import AssessMentSuggestionRecords from './assesment-suggestion'
import LabsImagingRecords from './labs-imaging'
import MobilitiesRecords from './mobility-assessment'
const AssessmentRecords = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, diagnosisName, setPatientDBdata, noteID }) => {

    const [finalScore, setFinalScore] = useState(0)
    const [date, setDate] = useState("")
    const [mobilityAssessment, setMobilityAssessment] = useState("")
    const [freetype, setFreeType] = useState("")
    const [tempFreeType, setTempFreeType] = useState("")
    const [isHavingMobilityAssessment, setIsHavingMobilityAssessment] = useState(false)
    const [isHavingAssessmentSuggestions, setIsHavingAssessmentSuggestions] = useState(false)
    const [isHavingLabImaging, setIsHavingLabImaging] = useState(false)

    const [LabImaging, setLabImaging] = useState("")

    useEffect(() => {

        const date = patientDBdata?.currentNote?.data?.MorseScore?.[diagnosisName]?.date
        const score = patientDBdata?.currentNote?.data?.MorseScore?.[diagnosisName]?.finalScore
        setFinalScore(score)
        setDate(date)


        const mobilityValues = patientDBdata?.currentNote?.data?.MobilityAssessment?.assessment || {}
        setMobilityAssessment(mobilityValues)

        const freeType = patientDBdata?.currentNote?.data?.assessment?.[diagnosisName]?.FreeType || ""
        setFreeType(freeType)
        setTempFreeType(freeType)

        const labImaging = patientDBdata?.currentNote?.data?.assessment?.[diagnosisName]?.LabImaging || ""
        setLabImaging(labImaging)


        // const assessmentSuggestions = patientDBdata?.currentNote?.data?.assessment?.[diagnosisName]?.assessmentSuggestions || ""
        // setAssessmentSuggestions(assessmentSuggestions)

        

    }, [patientDBdata])



    const handleBlur = () => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        alertData: {
                            ...prev?.currentNote?.data?.alertData,
                            [diagnosisName]: modalText,
                        },
                    },
                },
                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteID) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}
                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                alertData: {
                                    ...parsedData?.alertData,
                                    [diagnosisName]: modalText,
                                },
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }
    const handleFreeTypeBlur = () => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        assessment: {
                            ...prev?.currentNote?.data?.assessment,
                            [diagnosisName]: {
                                ...prev?.currentNote?.data?.assessment?.[diagnosisName],
                                FreeType: tempFreeType,
                            },
                        },
                    },
                },
                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteID) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}
                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                assessment: {
                                    ...parsedData?.assessment,
                                    [diagnosisName]: {
                                        ...parsedData?.assessment?.[diagnosisName],
                                        FreeType: tempFreeType,
                                    },
                                },
                            }),
                        }
                    }
                    return note
                })
            }
        })
    }

    return (
        <div className='w-100'>
       {  (isHavingAssessmentSuggestions || isHavingLabImaging || isHavingMobilityAssessment || finalScore || freetype ) &&  <p>Assessments</p>}
            {/* Mobility Assessment */} 
<MobilitiesRecords  diagnosisName={diagnosisName} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} isHavingMobilityAssessment={isHavingMobilityAssessment} setIsHavingMobilityAssessment={setIsHavingMobilityAssessment} />

            {/* Morse */}
            {finalScore && date &&
                <div>
                    Score: {finalScore} Date: {date}
                </div>}

<AssessMentSuggestionRecords   diagnosisName={diagnosisName} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} isHavingAssessmentSuggestions ={isHavingAssessmentSuggestions} setIsHavingAssessmentSuggestions={setIsHavingAssessmentSuggestions}/>
                 

            {/* Freetype */}
            <div>
                {freetype && 
                <GraytextareaAdjustable
                onBlur={handleFreeTypeBlur}
                    value={tempFreeType}
                    onChange={(e) => setTempFreeType(e.target.value)}
                    label="Free Type"
                />}
            </div>

<LabsImagingRecords   diagnosisName={diagnosisName} isSavingTheData={isSavingTheData} noteID={noteID} setPatientDBdata={setPatientDBdata} patientDBdata={patientDBdata} patientID={patientID} loggedUserProvider={loggedUserProvider} isHavingLabImaging={isHavingLabImaging} setIsHavingLabImaging={setIsHavingLabImaging} />
        </div>
    )
}


export default AssessmentRecords